export const TARGET_SCREEN_VIDEO_ID = "target-screen-video"